import { emailValidator, numberValidator } from '../fields';

const config = { mandatory: true };

const superSplashTop = {
  connectionTTL: numberValidator(config)
};

const splashTop = {
  email: emailValidator(config)
};

const ownSplashTop = {
  accountEmail: emailValidator(config)
};

export default {
  splashTop,
  superSplashTop,
  ownSplashTop
};
